// メンテナンス設定
export interface MaintenanceConfig {
  isMaintenance: boolean
  maintenancePaths: string[]
  maintenancePagePath: string
}

export const MAINTENANCE_CONFIG: MaintenanceConfig = {
  // メンテナンス中かどうか
  isMaintenance: process.env.VUE_APP_MAINTENANCE_MODE === 'true',

  // メンテナンス対象のパス
  maintenancePaths: [
  ],

  // メンテナンス画面のパス
  maintenancePagePath: '/maintenance',
}

// パスがメンテナンス対象かどうかを判定
export function isMaintenancePath(path: string): boolean {
  // メンテナンスページ自体は除外
  if (path === MAINTENANCE_CONFIG.maintenancePagePath) {
    return false
  }

  return MAINTENANCE_CONFIG.maintenancePaths.some(maintenancePath => {
    // パラメータ部分を正規表現に変換
    const regexPattern = maintenancePath
      .replace(/:[^/]+/g, '[^/]+') // :club_slug などを [^/]+ に変換
      .replace(/\//g, '\\/') // / をエスケープ
    const regex = new RegExp(`^${regexPattern}$`)

    return regex.test(path)
  })
}

// メンテナンス中かどうかを判定
export function isUnderMaintenance(): boolean {
  return MAINTENANCE_CONFIG.isMaintenance
}
